import OutputSelectionManager from "../manager/OutputSelectionManager";
import {satGlobals} from "../../../../../sat/helper/sat-globals";
import axios from 'axios';
import {useResultPageStore} from "../stores/ResultPageStore";

class Analytics {

    listener = false;

    constructor() {
    }

    async send(metric, action, job = {apiJob: { id: 'no_id', sat: { operation: 'no_operation' }}}) {
        await axios.post( satGlobals.getApiUrl('api/z'), {data: {message: metric, job_id: job.apiJob.id, action: action, operation: job.apiJob.sat.operation}}, { withCredentials: true });
  }
}

export default new Analytics()